function ProviderLogin() {
  window.location.replace(process.env.REACT_APP_COGNITO_PROVIDER_SIGNIN);
}

function ProviderSignup() {
  window.location.replace(process.env.REACT_APP_COGNITO_PROVIDER_SIGNUP);
}

export { ProviderLogin, ProviderSignup };
